import { EstimateTemplateRecord, estimateTemplateFromJSON } from "common/records/EstimateTemplate";
import { RootActions, RootState } from "common/reducers";
import {
  EstimateTemplateActions,
  EDIT_ESTIMATE_TEMPLATE,
  EDIT_ESTIMATE_TEMPLATES,
  FETCH_ESTIMATE_TEMPLATE,
  RECEIVE_ESTIMATE_TEMPLATE,
  RECEIVE_ESTIMATE_TEMPLATES,
  REMOVE_ESTIMATE_TEMPLATE,
  SET_ESTIMATE_TEMPLATE_LOADED,
} from "common/reducers/estimateTemplate.actions";
import { Map, Record } from "immutable";
import { fetch, receive } from "common/reducers/Utils";
import { reducer as imageReducer } from "common/reducers/image.reducer";
import { reducer as documentReducer } from "common/reducers/document.reducer";
import { ImageActions } from "common/reducers/image.actions";
import { DocumentActions } from "common/reducers/document.actions";

export const EstimateTemplateStateRecord = Record({
  byId: Map<number, EstimateTemplateRecord>(),
  lastSavedById: Map<number, EstimateTemplateRecord>(),
});

export const initialState = EstimateTemplateStateRecord();
export type EstimateTemplateState = typeof initialState;
export const model = "estimateTemplates";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case FETCH_ESTIMATE_TEMPLATE:
      return fetch(state, model, estimateTemplateFromJSON({ id: action.payload.id })) as RootState;

    case SET_ESTIMATE_TEMPLATE_LOADED:
      return state.setIn([model, "byId", action.payload.id, "loading"], false);

    case RECEIVE_ESTIMATE_TEMPLATE:
      // Side-load the template's attached files into the global image/document stores so the apply
      // path can resolve their urls when restoring files onto custom line items.
      action.payload.estimateTemplate.images?.forEach((image) => {
        state = imageReducer(state, ImageActions.receiveImage(image));
      });
      action.payload.estimateTemplate.documents?.forEach((document) => {
        state = documentReducer(state, DocumentActions.receiveDocument(document));
      });
      return receive(state, model, estimateTemplateFromJSON(action.payload.estimateTemplate)) as RootState;

    case RECEIVE_ESTIMATE_TEMPLATES:
      action.payload.estimateTemplates.forEach((estimateTemplate) => {
        state = reducer(state, EstimateTemplateActions.receiveEstimateTemplate(estimateTemplate));
      });
      return state;

    case EDIT_ESTIMATE_TEMPLATE:
      return state.setIn([model, "byId", action.payload.id, action.payload.name], action.payload.value);

    case EDIT_ESTIMATE_TEMPLATES:
      action.payload.ids.forEach((id) => {
        state = reducer(
          state,
          EstimateTemplateActions.editEstimateTemplate(id, action.payload.name, action.payload.value),
        );
      });
      return state;

    case REMOVE_ESTIMATE_TEMPLATE:
      return state.deleteIn([model, "byId", action.payload.id]);

    default:
      return state;
  }
};
